/* eslint-disable no-global-assign */
export const globalDebug = (function () {
  let savedConsole = console;
  /**
   * @param {boolean} debugOn
   * @param {boolean} suppressAll
   */
  return function (debugOn, suppressAll) {
    let suppress = suppressAll || false;

    if (debugOn === false) {
      // supress the default console functionality
      console = {
        group: function () {},
        groupEnd: function () {},
      };
      console.log = function () {};
      // supress all type of consoles
      if (suppress) {
        console.info = function () {};
        console.warn = function () {};
        console.error = function () {};
      } else {
        console.info = savedConsole.info;
        console.warn = savedConsole.warn;
        console.error = savedConsole.error;
      }
    } else {
      console = savedConsole;
    }
  };
})();
